const isEmptyObject = (arg: any): boolean => arg && Object.entries(arg).length === 0 && arg.constructor === Object;

export default isEmptyObject;
